<div class="hh-layout">
  <!-- Header bar -->
  <div class="hh-header">
    <span class="hh-header-title">Uniformax</span>
    <div class="hh-header-actions">
      <span class="hh-user-badge">{{ userInitials }}</span>
      <button pButton type="button" class="p-button-text p-button-sm" title="Logout" (click)="logout()">
        <i class="pi pi-sign-out"></i>
      </button>
    </div>
  </div>

  <!-- Content area -->
  <div class="hh-content">
    <router-outlet></router-outlet>
  </div>
</div>
